"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmartValveV6Model = void 0;
var _react = _interopRequireDefault(require("react"));
var _drei = require("@react-three/drei");
var _reactErrorBoundary = require("react-error-boundary");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
const _excluded = ["onPointerOver", "onClick", "onPointerMissed", "onPointerOut", "deviceRotate"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SmartValveV6ModelContent = props => {
  const {
      onPointerOver,
      onClick,
      onPointerMissed,
      onPointerOut,
      deviceRotate = [0, 0, 0] // [x, y, z]
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/102_paul_smart_valve_warmwater_V6.glb"));
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  return /*#__PURE__*/_react.default.createElement("group", _extends({
    dispose: null,
    visible: true,
    rotation: deviceRotate
  }, p), /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [40, 40, 40]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("group", {
    onPointerOver: onPointerOver,
    onClick: onClick,
    onPointerMissed: onPointerMissed,
    onPointerOut: onPointerOut
  }, /*#__PURE__*/_react.default.createElement("mesh", {
    position: [1.4, 1.1, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [4.6, 10.2, 4]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_color_label_blue'].geometry,
    material: materials['Component.LabelBlueLight'],
    position: [1.6, 1.65, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_basepipe'].geometry,
    material: materials['Component.WhiteObjects'],
    position: [0, -4, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_paul_logo_blue'].geometry,
    material: materials['Component.EmissionBlau'],
    position: [1.6, 1.65, 0],
    rotation: [Math.PI / 2, 0, -Math.PI / 2]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['04_body_light'].geometry,
    material: materials['Component.WhiteObjects'],
    position: [1.6, 1.65, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['05_body_gray'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [1.6, 1.65, 0]
  }, shadows))));
};
const SmartValveV6Model = exports.SmartValveV6Model = (0, _reactErrorBoundary.withErrorBoundary)(SmartValveV6ModelContent, {
  FallbackComponent: () => null,
  // eslint-disable-next-line no-console
  onError: (err, info) => console.error(err, info)
});